/**
 * Print developer message in browser
 */
export function printDeveloperMessageToConsole() {
  console.log(
    "%cInteresse an dem was wir machen?",
    "color: #e6b381; font-size: x-large"
  );
  console.log(
    "%cDu kannst es genau so gut oder sogar besser?",
    "color: #e6b381; font-size: x-large"
  );
  console.log(
    "%cDann melde dich bei uns! hallo@mbagentur.de / +49 351 43813–0",
    "color: darkgray; font-size: large"
  );
}
